module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentPaneKey === 'instance') ? _c('div', {
    staticClass: "pane-template"
  }, [(!_vm.hideHeader) ? _c('pane-header', {
    attrs: {
      "title": _vm.instance.title,
      "subtitle": _vm.instance.sub,
      "tools": _vm.tools,
      "appIconKey": _vm.instance.type,
      "hasCloseIcon": true
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-details', {
    attrs: {
      "cover": "cover",
      "title": _vm.instance.name,
      "list": [{
          label: 'Standard Identifiers',
          value: _vm.instance.identifiers,
        },

        {
          label: 'Source',
          value: _vm.instance.source,
        },
        {
          label: 'Subject(s)',
          value: _vm.instance.subjects,
        },
        {
          label: 'Edition',
          value: _vm.instance.edition,
        },
        {
          label: 'Publisher',
          value: _vm.instance.publisher,
        },
        {
          label: 'Publication date',
          value: _vm.instance.publication_date,
        },
        {
          label: 'Resource type',
          value: _vm.instance.resource_type,
        } ]
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related packages",
      "itemCount": _vm.instance.packageCount,
      "preset": "package",
      "tools": _vm.tools
    }
  }), _vm._v(" "), (false) ? _c('pane-section', {
    attrs: {
      "title": "Related orders",
      "preset": "order",
      "tools": _vm.tools
    }
  }) : _vm._e(), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related items",
      "preset": "item",
      "tools": _vm.tools
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f8d865","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pane-templates/InstancePaneTemplate.vue
// module id = 426
// module chunks = 1